import { AbstractControl, Validators } from "@angular/forms";

/** Valor do caractere conforme spec Receita Federal: dígito → valor numérico; letra A-Z → ASCII - 48 */
function charValue(ch: string): number {
    const code = ch.toUpperCase().charCodeAt(0);
    if (code >= 48 && code <= 57) return code - 48; // '0'-'9'
    if (code >= 65 && code <= 90) return code - 48; // 'A'-'Z': ASCII - 48
    return -1;
}

/** Remove máscara e normaliza para maiúsculas, preservando letras A-Z */
export function unmaskCnpj(value: string): string {
    return value.replace(/[.\-/]/g, '').toUpperCase();
}

export class CnpjValidator {
    static isValid(control: AbstractControl): { [key: string]: any } | null {
        if (control.value) {
            const cnpj = unmaskCnpj(control.value);
            const isAlphanumeric = /[A-Z]/.test(cnpj);
            const error = { "invalid-cnpj": { alphanumeric: isAlphanumeric } };

            if (cnpj === '') return error;
            if (cnpj.length !== 14) return error;

            // Dígitos verificadores (posições 12 e 13) devem ser numéricos
            if (!/^\d$/.test(cnpj[12]) || !/^\d$/.test(cnpj[13]))
                return error;

            // Rejeita todos os caracteres iguais
            if (/^(.)\1*$/.test(cnpj)) return error;

            // Valida caracteres válidos: A-Z ou 0-9
            if (!/^[A-Z0-9]{14}$/.test(cnpj)) return error;

            // Pesos conforme spec Receita Federal
            const weights1 = [5,4,3,2,9,8,7,6,5,4,3,2];
            const weights2 = [6,5,4,3,2,9,8,7,6,5,4,3,2];

            let sum1 = 0;
            for (let i = 0; i < 12; i++) sum1 += charValue(cnpj[i]) * weights1[i];
            const d1 = sum1 % 11 < 2 ? 0 : 11 - (sum1 % 11);
            if (d1 !== parseInt(cnpj[12])) return error;

            let sum2 = 0;
            for (let i = 0; i < 13; i++) sum2 += charValue(cnpj[i]) * weights2[i];
            const d2 = sum2 % 11 < 2 ? 0 : 11 - (sum2 % 11);
            if (d2 !== parseInt(cnpj[13])) return error;

            return null;
        } else {
            if (!control.hasValidator(Validators.required)) { return {}; }
            return { "invalid-cnpj": { alphanumeric: false } };
        }
    }
}
